$(document).ready(function () {
    let x = window.matchMedia("(max-width: 820px)")

    function myFunction(x) {
        if (x.matches && $('.sidebar').hasClass('active')) { // If media query matches
            $('body').addClass('overflow-hidden');
        } else {
            $('body').removeClass('overflow-hidden');
        }
    }

    myFunction(x)
    x.addEventListener('change', function(event) {
        myFunction(event.target);
    });

    $(document).on('click', '.btn-menu', function () {
        updateHeaderHeight();
        $('.sidebar').addClass('active');
        $('.btn-menu').css('display', 'none');
        $('.btn-close-sidebar').css('display', 'flex');
        $('body').addClass('overflow-hidden');
    });

    $(document).on('click', '.btn-close-sidebar', function () {
        $('.sidebar').removeClass('active');
        $('.btn-menu').css('display', 'flex');
        $('.btn-close-sidebar').css('display', 'none');
        $('body').removeClass('overflow-hidden');
    });

    $('.sub-btn').click(function () {
        $(this).next('.sub-menu').slideToggle();
        $(this).find('.dropdown').toggleClass('rotate');
    })

    $(document).on('click', '.btn-back-to-top', function () {
        $('html, body').animate({scrollTop: 0}, 1000);
    })

    document.querySelectorAll('.dropdown-toggle').forEach(dropDownFunc);

    function dropDownFunc(dropDown) {

        if (dropDown.classList.contains('click-dropdown') === true) {
            dropDown.addEventListener('click', function (e) {
                e.preventDefault();

                if (this.nextElementSibling.classList.contains('dropdown-active') === true) {
                    this.parentElement.classList.remove('dropdown-open');
                    this.nextElementSibling.classList.remove('dropdown-active');

                } else {
                    closeDropdown();

                    this.parentElement.classList.add('dropdown-open');
                    this.nextElementSibling.classList.add('dropdown-active');
                }
            });
        }

        window.addEventListener('click', function (e) {
            if (e.target.closest('.dropdown-container') === null) {
                closeDropdown();
            }
        });


        function closeDropdown() {

            document.querySelectorAll('.dropdown-container').forEach(function (container) {
                container.classList.remove('dropdown-open')
            });

            document.querySelectorAll('.dropdown-menu').forEach(function (menu) {
                menu.classList.remove('dropdown-active');
            });
        }

        document.querySelectorAll('.dropdown-menu').forEach(function (dropDownList) {
            dropDownList.onmouseleave = closeDropdown;
        });

    }

    if (window.location.href == $('.route-participant-note').val()) {
        $([document.documentElement, document.body]).animate({
            scrollTop: $('#focus-participant-note').offset().top - 100
        }, 500);
    }

    $(document).on('click', '.noti-bid-permission .icon-close', function () {
        $(this).closest('.noti-bid-permission').addClass('d-none')
    })

    $(document).on('click', '.noti-bid-permission', function (event) {
        if (!($(event.target).closest('.modal-1').length)) {
            $(this).closest('.noti-bid-permission').addClass('d-none')
        }
    })

    function handleLogicShowPassword (element, inputName) {
        $(document).on('click', element, function () {
            const elementPassword = $(this).closest('.password-container').find(`input[name=${inputName}]`);
            const inputType = elementPassword.attr('type');

            if(inputType === 'password') {
                elementPassword.attr('type', 'text');
            } else {
                elementPassword.attr('type', 'password');
            }
            $(this).toggleClass('fa-eye-slash').toggleClass('fa-eye');
        })
    }

    handleLogicShowPassword('#show-password', 'password');
    handleLogicShowPassword('#show-password', 'new_password');
    handleLogicShowPassword('#show-password', 'confirm_new_password');

    //show banner top page
    let imgBanners = document.querySelectorAll('.banner-image img')
    let desBanners = document.querySelectorAll('.banner-image .banner-description')
    let currentIndex = 0;
    let totalBanners = imgBanners.length;
    let interval;

    function resetBanners(elements) {
        if(elements) {
            elements.forEach(element => {
                element.classList.remove('active-previous','active-next', 'previous', 'next');
            })
        }
    }

    function showNextBanner() {
        if(totalBanners > 1) {
            resetBanners(imgBanners);
            resetBanners(desBanners);
            updateIndexNextBanner();
            updateCircleBanner();
        }
    }

    function updateIndexNextBanner() {
        if (imgBanners[currentIndex] && desBanners[currentIndex]) {
            imgBanners[currentIndex].classList.add('previous');
            desBanners[currentIndex].classList.add('previous');
            currentIndex = (currentIndex + 1) % totalBanners;
            imgBanners[currentIndex].classList.add('active-next');
            desBanners[currentIndex].classList.add('active-next');
        }
    }

    function showPreviousBanner() {
        if(totalBanners > 1) {
            resetBanners(imgBanners);
            resetBanners(desBanners);
            updateIndexPreviousBanner();
            updateCircleBanner();
        }
    }

    function updateIndexPreviousBanner() {
        if(imgBanners[currentIndex] && desBanners[currentIndex]) {
            imgBanners[currentIndex].classList.add('next');
            desBanners[currentIndex].classList.add('next');
            currentIndex = (currentIndex - 1 + totalBanners) % totalBanners;
            imgBanners[currentIndex].classList.add('active-previous');
            desBanners[currentIndex].classList.add('active-previous');
        }
    }

    function showBannerByIndexCircle(newIndex) {
        if(newIndex < currentIndex) {
            for (let i = currentIndex; i > newIndex; i--) {
                setTimeout(() => {
                    resetBanners(imgBanners);
                    resetBanners(desBanners);
                    updateIndexPreviousBanner();
                }, i * 100);
            }
        } else if(newIndex > currentIndex) {
            for (let i = currentIndex; i < newIndex; i++) {
                setTimeout(() => {
                    resetBanners(imgBanners);
                    resetBanners(desBanners);
                    updateIndexNextBanner();
                }, i * 100);
            }
        }
    }

    function startAutoSlide() {
        if(totalBanners > 1) {
            interval = setInterval(showNextBanner, 5000);
        }
    }

    function stopAutoSlide() {
        clearInterval(interval);
    }

    function updateCircleBanner() {
        $(`.icon-circle`).removeClass('active');
        for (let index = 0; index < imgBanners.length; index++) {
            let item = imgBanners[index];
            if (item.classList.contains('active-next') || item.classList.contains('active-previous')) {
                $(`.icon-circle#banner-${index}`).addClass('active');
                break;
            }
        }
    }


    $(document).on('click', '.cheron-right', function () {
        stopAutoSlide();
        showNextBanner();
        startAutoSlide();

    })

    $(document).on('click', '.cheron-left', function () {
        stopAutoSlide();
        showPreviousBanner();
        startAutoSlide();
    })

    $(document).on('click', '.icon-circle', function () {
        stopAutoSlide();
        $(`.icon-circle`).removeClass('active');
        $(this).addClass('active');
        let newIndex = $(this).data('index');
        showBannerByIndexCircle(newIndex);
        startAutoSlide();
    })

    $('.banner-image img, .banner-image .banner-description').hover(
        function() {
            stopAutoSlide();
        },
        function() {
            startAutoSlide();
        }
    );

    startAutoSlide();

    $(document).on('click', '#logout, .js-logout', function (e) {
        e.preventDefault();
        checkAndLogout($(this));
    });

    function resolveLogoutForm($trigger) {
        if ($trigger && $trigger.length) {
            const siblingForm = $trigger.siblings('#logout-form');
            if (siblingForm.length) {
                return siblingForm.first();
            }
            const listItemForm = $trigger.closest('li').siblings('#logout-form');
            if (listItemForm.length) {
                return listItemForm.first();
            }
            const subMenuForm = $trigger.closest('.sub-menu').find('#logout-form');
            if (subMenuForm.length) {
                return subMenuForm.first();
            }
        }

        return $('#logout-form').first();
    }

    const checkAndLogout = ($trigger) => {
        const $logoutForm = resolveLogoutForm($trigger);
        if (!$logoutForm.length) {
            return;
        }

        let csrfToken = $('meta[name="csrf-token"]').attr('content');

        $.ajax({
            url: '/check-csrf',
            type: 'GET',
            beforeSend: function (xhr) {
                xhr.setRequestHeader('X-CSRF-TOKEN', csrfToken);
            },
            success: function (response) {
                if (response.csrf_token !== csrfToken) {
                    $('meta[name="csrf-token"]').attr('content', response.csrf_token);
                    $logoutForm.find('input[name="_token"]').val(response.csrf_token);
                    csrfToken = response.csrf_token;
                }

                $logoutForm.get(0).submit();
            },
            error: function (xhr, status, error) {
                console.log(error);
                // Fallback: submit form anyway, VerifyCsrfToken will handle expired sessions
                $logoutForm.get(0).submit();
            }
        });
    }

    // Handle auction selection dropdown scroll
    $(document).on('change', '.select-auction-home-page', function() {
        let selectedAuctionId = $(this).val();

        if (selectedAuctionId && selectedAuctionId !== '') {
            let targetElement = $('#auction-' + selectedAuctionId);

            if (targetElement.length) {
                $('html, body').animate({
                    scrollTop: targetElement.offset().top - 100
                }, 500);
            }
        }
    });

    function updateHeaderHeight() {
        const header = document.querySelector('.header-container');
        if (header) {
            document.documentElement.style.setProperty('--home-header-height', `${header.offsetHeight}px`);
        }
    }

    function updateContentOffset() {
        const header = document.querySelector('.header-container');
        const content = document.querySelector('.content');
        const path = window.location.pathname;

        updateHeaderHeight();

        if (header && content && (path === '/' || path === '/home')) {
            content.style.paddingTop = `${header.offsetHeight}px`;
        }
    }

    window.addEventListener('load', updateContentOffset);
    window.addEventListener('resize', updateContentOffset);
});
